import * as React from "react";
const ArrowOutward = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "#666666"}
      d="M16.2875 9.1125L7.38752 18.0125C7.20419 18.1958 6.97086 18.2875 6.68752 18.2875C6.40419 18.2875 6.17086 18.1958 5.98752 18.0125C5.80419 17.8292 5.71252 17.5958 5.71252 17.3125C5.71252 17.0292 5.80419 16.7958 5.98752 16.6125L14.8875 7.7125H7.28752C7.00419 7.7125 6.76669 7.61667 6.57502 7.425C6.38336 7.23333 6.28752 6.99583 6.28752 6.7125C6.28752 6.42917 6.38336 6.19167 6.57502 6C6.76669 5.80833 7.00419 5.7125 7.28752 5.7125H17.2875C17.5709 5.7125 17.8084 5.80833 18 6C18.1917 6.19167 18.2875 6.42917 18.2875 6.7125V16.7125C18.2875 16.9958 18.1917 17.2333 18 17.425C17.8084 17.6167 17.5709 17.7125 17.2875 17.7125C17.0042 17.7125 16.7667 17.6167 16.575 17.425C16.3834 17.2333 16.2875 16.9958 16.2875 16.7125V9.1125Z"
    />
  </svg>
);
export default ArrowOutward;
